/**************************************************
 * Nombre:       Producto_Detalles
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Chip, Grid, Typography} from "@mui/material";
import {theme} from "../../../../../Tema";
import {PointOfSaleOutlined, ShoppingCartOutlined} from '@mui/icons-material'
import metodo from '../../../../../Recursos/metodos.png'
import {useProductosCarrito} from "../../../../../Modulo_Carrito_Flotante/Funcionamiento/Hooks/useProductosCarrito";
import {useCarritoFlotante} from "../../../../../Modulo_Carrito_Flotante/Hooks/useCarritoFlotante";
import {formatoMoneda} from "../../../../../Utilidades/formatoMoneda";
import {useEffect, useState} from "react";
import {adap_item_producto_carrito} from "../../../../Adaptador/adap_item_producto_carrito";


const Producto_Detalles = ({item}) => {
    const {productos, agregarProducto, estaProducto, obtenerProducto} = useProductosCarrito()
    const [escogido, setEscogido] = useState('')
    const {abrir, Carrito} = useCarritoFlotante()

    useEffect(() => {

        if (item && item.variantes && item.variantes.length > 0) {

            if (estaProducto('')){
                setEscogido(item.variantes[0])
            }

        }


    }, [item])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Carrito/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography
                    sx={{
                        fontSize: 14,
                        fontWeight: 600,
                        color: '#fff',
                        backgroundColor: item.estado === 'In Stock' ?  theme.palette.primary.main : '#00000050',
                        px: 1,
                        borderRadius: 1
                    }}>
                    {item.estado}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography
                    sx={{fontSize: 24, fontWeight: 600}}>
                    {item.nombre}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography
                    sx={{fontSize: 16, fontWeight: 300, color: '#00000090'}}>
                    {item.descripcion}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography
                    sx={{fontSize: 28, fontWeight: 700, color: theme.palette.primary.main}}>
                    {formatoMoneda(escogido.valor)}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>


                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={2}
                >

                    {item.variantes && item.variantes.map((it, index) => {
                        return (
                            <Grid
                                onClick={() => setEscogido(it)}
                                container
                                justifyContent={'flex-start'}
                                alignItems={'center'}
                                size={{xs: 12, sm: 12, md: 4}}
                                sx={{
                                    border: escogido.nombre === it.nombre ? 2 : 1,
                                    borderColor: escogido.nombre === it.nombre ? theme.palette.secondary.main : '#00000050',
                                    borderRadius: 2,
                                    cursor: 'pointer',
                                    p: 1
                                }}
                                spacing={2}
                            >


                                <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={0}
                                    >

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Typography sx={{
                                                color: escogido.nombre === it.nombre ? theme.palette.secondary.main : '#00000050',
                                                fontSize: 14,
                                                fontWeight: 500
                                            }}>{'Unidad'}</Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: -0.2}}>
                                            <Typography sx={{fontWeight: 600,}}>{it.nombre}</Typography>
                                        </Grid>

                                    </Grid>
                                </Grid>

                            </Grid>
                        )
                    })}

                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}
                  spacing={4}
            >
                <Button
                    disabled={item.estado !== 'In Stock'}
                    onClick={() => agregarProducto(adap_item_producto_carrito({entidad: item, variante: escogido}))}
                    variant={'outlined'}
                    sx={{color: theme.palette.primary.main, py: 2, fontWeight: 500, width: 250}}
                    startIcon={<ShoppingCartOutlined/>}>
                    {obtenerProducto(item.id) ? `${obtenerProducto(item.id).cantidad} Agregados` : 'Agregar al carrito'}
                </Button>

                <Button
                    disabled={item.estado !== 'In Stock'}
                    onClick={() => {
                        agregarProducto(adap_item_producto_carrito({entidad: item, variante: escogido}))
                        abrir()
                    }
                    }
                    sx={{py: 2, fontWeight: 500, width: 250}}
                    startIcon={<PointOfSaleOutlined/>}>Comprar Ahora</Button>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Typography sx={{fontSize: 14, color: '#00000090', fontWeight: 500}}>Tipo Mascota:
                    {/*tipos.map((it, index) => {
                        return (
                            <span style={{marginLeft: 6, fontWeight: 400, color: '#000'}}>{it}</span>
                        )
                    })*/}
                    <span>
                          <Chip label={item.tipo} sx={{ml: 1}} size={'medium'} variant={'filled'} color={'primary'}/>
                    </span>

                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0.5}}>
                <Typography sx={{fontSize: 14, color: '#00000090', fontWeight: 500}}>Categorias:
                    {/*tipos.map((it, index) => {
                        return (
                            <span style={{marginLeft: 6, fontWeight: 400, color: '#000'}}>{it}</span>
                        )
                    })*/}

                    <span>
                          <Chip label={item.categoria} sx={{ml: 1}} size={'medium'} variant={'filled'}
                                color={'primary'}/>
                    </span>
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <img src={metodo} width={'80%'} height={'auto'}/>
            </Grid>


        </Grid>
    )

}
export default Producto_Detalles
